import TransitApi from './base'

export default {
  async getAll(params = {}) {
    try {
      const Api = TransitApi.getSecureInstance()
      const queryString = TransitApi.getQueryString(params)
      const result = await Api.get(`/holiday/all?${queryString}`)
      return result.data
    } catch (error) {
      return error.response
    }
  },

  async save(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const path = params.id ? `/holiday/details/${params.id}` : '/holiday/add'
      const result = await Api.post(path, params)
      return result
    } catch (error) {
      return error.response
    }
  },

  async delete(id) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.delete(`/holiday/${id}`)
      return result
    } catch (error) {
      return error.response
    }
  },
}
